
const ClockIcon = () => {
    return (
        <svg width="19px" height="19px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="PathPilotApp" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
                <g id="PPDesktopChatThreadJobDetailFlyout1920Copy10" transform="translate(-88, -206)" stroke="#000000" strokeWidth="2">
                    <g id="Group" transform="translate(89, 207)">
                        <polyline id="Stroke311Copy" points="6.57192 4.26428171 6.57192 10.2039503 11.9194486 10.2039503"></polyline>
                        <path d="M16.68,8.34 C16.68,12.9465636 12.9465636,16.68 8.34,16.68 C3.73406547,16.68 0,12.9465636 0,8.34 C0,3.73406547 3.73406547,0 8.34,0 C12.9465636,0 16.68,3.73406547 16.68,8.34 Z" id="Stroke316Copy"></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default ClockIcon;
